/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import OtherCharges from "./OtherCharges";

const OtherChargesContainer = () => {
  const otherCharges = [
    [
      "Payment Gateway Charges",
      "<span>₹9 + GST</span>"
    ],
    [
      "Delayed Payment Charges",
      "<span>21 % per year</span>"
    ],
    [
      "Call & Trade charges",
      "<span>₹50 + GST per order</span>"
    ]
  ];

  return (
    <OtherCharges otherCharges={otherCharges} />
  );
};

export default OtherChargesContainer;
